// Core
import { useCallback, useState } from 'react';
import {  useQuery } from 'react-query';

// Chakra
import {

  Text,
  useColorModeValue,
  Divider, Button, Flex, Table, Thead, Tr, Td, Tbody
} from '@chakra-ui/react';

// Assets
import { apiService } from 'services/ApiService';

// Components
import NotFound from 'views/Dashboard/404.js';
import Pagination from '../../../components/Pagination';
import { useHistory } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa6';
import Card from '../../../components/Card/Card';
import TableSkeleton from '../../../components/TableSkeleton';
import { parseDateTime } from '../../../services/Utils';

const PosTransaction = () => {

  const history = useHistory();
  const borderColor = useColorModeValue('blue.50', 'rgba(255, 255, 255, 0.10)');

  const textColor = useColorModeValue('gray.700', 'white');
  const paddingTd = '16px 0 16px 24px';
  const [offset, setOffset] = useState(0);
  const [posTransactions, setPosTransactions] = useState([]);
  const [posTransactionsMeta, setPosTransactionsMeta] = useState([]);
  const limit = 25;

  const { isFetching, refetch } = useQuery({
    queryKey: ['pos-transactions', offset],
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const params = {
        limit,
        offset,
      };

      const response = await apiService.getPosTransactions(params);
      setPosTransactions(response.data);
      setPosTransactionsMeta(response.meta);
      return true;
    },
    retry: false,
    refetchInterval: 30000,
  });


  const handleEditOpen = useCallback(
    (plan) => {
      history.push(`/pos-transactions/${plan.id}`);
    },
    [history],
  );


  return (
    <>
      <Flex justifyContent="space-between" alignItems="center">
        <Text fontSize='40px' fontStyle='normal' fontWeight='700' color={textColor} mb='0px' className="page-name">POS Transactions</Text>
      </Flex>

      <Divider opacity="1" mr="2px" borderColor={borderColor} borderTopWidth="1px" borderBottomWidth="0" mb='32px'/>

      {isFetching ? (
        <TableSkeleton rowCount={5} />
      )
      :posTransactions.length > 0 ? (
        <Card padding={'8px'}>
          <Table color={textColor}>
            <Thead>
              <Tr>
                <Td>
                  <Text variant="title-md" p="0 0 6px 0">
                    Store ID
                  </Text>
                </Td>
                <Td>
                  <Text variant="title-md" p="0 0 6px 0">
                    Terminal ID
                  </Text>
                </Td>
                <Td>
                  <Text variant="title-md" p="0 0 6px 0">
                    Sale Type
                  </Text>
                </Td>
                <Td>
                  <Text variant="title-md" p="0 0 6px 0">
                    Contract Level
                  </Text>
                </Td>
                <Td>
                  <Text variant="title-md" p="0 0 6px 0">
                    GST Total
                  </Text>
                </Td>
                <Td>
                  <Text variant="title-md" p="0 0 6px 0">
                    Currency
                  </Text>
                </Td>
                <Td>
                  <Text variant="title-md" p="0 0 6px 0">
                    Timestamp UTC
                  </Text>
                </Td>
                <Td>
                </Td>
              </Tr>
            </Thead>
            <Tbody>
              {posTransactions.map((row) => {
                return (
                  <Tr
                    onClick={() => handleEditOpen(row)}
                    _last={{
                    '& td': {
                      borderBottom: 'none !important',
                    },
                  }} key={row.id} border="unset" className="cursor-tr">
                    <Td verticalAlign="center" p={paddingTd}>
                      <Text variant="text" color={textColor}>
                        {row?.storeId}
                      </Text>
                    </Td>
                    <Td  verticalAlign="center" p={paddingTd}>
                      <Text variant="text" color={textColor}>
                        {row?.terminalId}
                      </Text>
                    </Td>
                    <Td verticalAlign="center" p={paddingTd}>
                      <Text variant="text" color={textColor}>
                        {row?.saleType}
                      </Text>
                    </Td>
                    <Td verticalAlign="center" p={paddingTd}>
                      <Text variant="text" color={textColor}>
                        {row?.contractLevel}
                      </Text>
                    </Td>
                    <Td verticalAlign="center" p={paddingTd}>
                      <Text variant="text" color={textColor}>
                        {row?.gstTotal}
                      </Text>
                    </Td>
                    <Td verticalAlign="center" p={paddingTd}>
                      <Text variant="text" color={textColor}>
                        {row?.currency}
                      </Text>
                    </Td>
                    <Td verticalAlign="center" p={paddingTd}>
                      <Text variant="text" color={textColor}>
                        {row?.timestampUtc}
                      </Text>
                    </Td>
                    <Td verticalAlign="center" p={paddingTd}>
                      <Button
                        variant="submit-ms"
                        maxW="140px"
                        w="100%"
                        onClick={handleEditOpen}
                      >
                        View details
                      </Button>
                    </Td>
                  </Tr>
                );
              })}
            </Tbody>
          </Table>
        </Card>
      ) : (
        <NotFound text="Not Found" />
      )}

      <Pagination
        meta={posTransactionsMeta ?? { limit, offset, total: 0 }}
        isLoadingPage={isFetching}
        currentPage={Math.floor(offset / limit) + 1}
        onPageChange={(newOffset) => setOffset(newOffset)}
      />
      {/*<Attention*/}
      {/*  variant="remove"*/}
      {/*  handle={() => handleDelete(object)}*/}
      {/*  isOpen={isOpen}*/}
      {/*  onOpen={onOpen}*/}
      {/*  onClose={onClose}*/}
      {/*/>*/}
    </>
  );
};

export default PosTransaction;
